export default {
  notes: [],
  notesMeta: {},
  notesAssetsByScope: {},
  notesAssetsLoadingByScope: {},
  notesAssetsErrorByScope: {},
  notesFilterOptionsByScope: {},
  activeNotesMemberId: '',
  researcherClients: [],
  projectsByClient: {},
  projectsLoadingByClient: {},
  projectsErrorByClient: {},
  skillSessionsByClient: {},
  skillSessionsLoadingByClient: {},
  skillSessionsErrorByClient: {},
  sharepointFilesByClient: {},
  sharepointFilesLoadingByClient: {},
  sharepointFilesErrorByClient: {},
  archiveFilesByClient: {},
  archiveFilesLoadingByClient: {},
  archiveFilesErrorByClient: {},
  researchMembersUpdating: false,
  notesLoading: false,
  notesLoadingRequestId: 0,
  note: null,
  noteLoading: false,
  noteUpdateLoading: false,
  unifiedSearchList: [],
  unifiedSearchMeta: {},
  unifiedSearchLoading: false,
  savedClients: {
    version: 4,
    selectedResearcher: null,
    selectedClientReference: {},
    lastResearchTab: '',
    otherSelectedClients: [],
    otherClientHistory: [],
  },
};
